import React, { useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import type { ContentItem } from "../data/content";
type AccordionProps = {
  items: ContentItem[];
  accent?: "lime" | "gold";
};
export function Accordion({
  items,
  accent = "lime"
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const accentClass = accent === "lime" ? "text-lime-300" : "text-amber-300";
  return <div className="space-y-3" data-id="element-77" data-mp="2n2nvt9x9fnvg">
      {items.map((item, index) => {
      const isOpen = openIndex === index;
      return <article key={item.title} className="overflow-hidden rounded-2xl border border-white/10 bg-black/45" data-id="element-78" data-mp="2i6yt4xpy1qux" data-mpi={index}>
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors hover:bg-white/[0.04] focus:outline-none focus:ring-2 focus:ring-lime-300 focus:ring-inset" aria-expanded={isOpen} data-id="element-79" data-mp="2s326z0u5rdxp">
              <span className="text-sm font-extrabold leading-5 text-white" data-id="element-80" data-mp="3g5x5ocf9ph5j">{item.title}</span>
              <ChevronDownIcon className={`h-5 w-5 shrink-0 ${accentClass} transition-transform ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-81" data-mp="3l3q7yudg9r0j" />
            </button>
            {isOpen && <div className="border-t border-white/10 px-4 py-4" data-id="element-82" data-mp="3uukxq8pwn8qq">
                <ul className="space-y-3" data-id="element-83" data-mp="3ngt1kh8fylh">
                  {item.details.map(detail => <li key={detail} className="text-sm leading-6 text-slate-300" data-id="element-84" data-mp="7nr61h3fzp9u">{detail}</li>)}
                </ul>
              </div>}
          </article>;
    })}
    </div>;
}